import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import {
  LayoutDashboard,
  Home,
  Menu as MenuIcon,
  FileText,
  Users,
  Settings,
  LogOut,
  Mail,
  Image,
  BookOpen,
  ArrowRightLeft,
} from 'lucide-react';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: Home, label: 'Homepage', path: '/admin/homepage' },
    { icon: MenuIcon, label: 'Menu', path: '/admin/menus' },
    { icon: FileText, label: 'Pages', path: '/admin/pages' },
    { icon: BookOpen, label: 'Blog', path: '/admin/blog' },
    { icon: Image, label: 'Footer', path: '/admin/footer' },
    { icon: Mail, label: 'Contacts', path: '/admin/contacts' },
    { icon: ArrowRightLeft, label: 'Redirects', path: '/admin/redirects' },
    { icon: Settings, label: 'Settings', path: '/admin/settings' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="w-64 bg-gray-900 text-white flex flex-col">
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-xl font-bold">Pulse NYC Admin</h1>
        <p className="text-sm text-gray-400 mt-1">{user?.email}</p>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
              }`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-800">
        <Button
          onClick={handleLogout}
          variant="ghost"
          className="w-full justify-start text-gray-300 hover:text-white hover:bg-gray-800"
        >
          <LogOut size={20} className="mr-3" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default AdminSidebar;
